import { useState, useMemo, useCallback } from "react";

type SortDirection = "asc" | "desc" | null;

export function useTableSorting<T extends any[]>(data: T[]) {
  const [sortColumn, setSortColumn] = useState<number | null>(null);
  const [sortDirection, setSortDirection] = useState<SortDirection>(null);

  const handleSort = useCallback((columnIndex: number) => {
    setSortColumn((prevColumn) => {
      if (prevColumn === columnIndex) {
        setSortDirection((prevDirection) => {
          if (prevDirection === "asc") return "desc";
          if (prevDirection === "desc") {
            setSortColumn(null);
            return null;
          }
          return "asc";
        });
        return prevColumn;
      }
      setSortDirection("asc");
      return columnIndex;
    });
  }, []);

  const sortedData = useMemo(() => {
    if (sortColumn === null || sortDirection === null) return data;

    return [...data].sort((a, b) => {
      const aValue = a[sortColumn];
      const bValue = b[sortColumn];

      if (aValue === bValue) return 0;
      if (aValue == null || aValue === "-") return 1;
      if (bValue == null || bValue === "-") return -1;

      const comparison = String(aValue).localeCompare(String(bValue), "pt-BR", { numeric: true });
      return sortDirection === "asc" ? comparison : -comparison;
    });
  }, [data, sortColumn, sortDirection]);

  return { sortedData, sortColumn, sortDirection, handleSort };
}
